import { SEARCH_SURROUNDING_SUBURBS_DEFAULT } from './defaults';
import { isPropertyStatusAllProperties } from './isPropertyStatusAllProperties';
import { isPropertyStatusOffMarket } from './isPropertyStatusOffMarket';

export const getSurroundingSuburbsOnPropertyStatusChange = (
  currentSurroundingSuburbs: string,
  newPropertyStatus?: string,
): string => {
  if (
    isPropertyStatusOffMarket(newPropertyStatus) ||
    isPropertyStatusAllProperties(newPropertyStatus)
  )
    return SEARCH_SURROUNDING_SUBURBS_DEFAULT;
  return currentSurroundingSuburbs;
};
